import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { FilesQuotaService } from './files-quota.service';
import { FmUploaderService } from '../file-uploader/fm-uploader.service';
import { first, takeUntil } from 'rxjs/operators';
import { NewFilesListService } from '../files-list/files-list.service';

@Component({
  selector: 'quota-image',
  templateUrl: './quota.html'
})
export class QuotaComponent implements AfterViewInit, OnDestroy {
  public quotaMBAvailableLabel: string;
  public quotaOutOfLabel: string;
  public quotaMBLabel: string;
  private destroy = new Subject();

  constructor(
    public filesQuotaService: FilesQuotaService,
    translate: TranslateService,
    private uploaderService: FmUploaderService,
    private newFileListService: NewFilesListService
  ) {
    this.quotaMBAvailableLabel = translate.instant('COMMON.QUOTA.QUOTA_MB_AVAILABLE');
    this.quotaOutOfLabel = translate.instant('COMMON.QUOTA.QUOTA_OUT_OF');
    this.quotaMBLabel = translate.instant('COMMON.QUOTA.QUOTA_MB');
  }

  ngAfterViewInit(): void {
    this.uploaderService.completedAll$.pipe(takeUntil(this.destroy)).subscribe(this.refreshStorageQuotaDetails);
    this.newFileListService.deletedFiles$.pipe(takeUntil(this.destroy)).subscribe(this.refreshStorageQuotaDetails);
  }

  private refreshStorageQuotaDetails = (): void => {
    this.filesQuotaService.subscribeToGetStorageQuota().pipe(first()).subscribe();
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }

}
